import { render } from "./OrderSummarySupplier.vue?vue&type=template&id=5987e8e0&ts=true"
import script from "./OrderSummarySupplier.vue?vue&type=script&lang=ts"
export * from "./OrderSummarySupplier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__